import instance from "./Instance/index.js";

export const createNotifi = async (values) => {
  try {
    const response = await instance.post(`/notifications`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getNotifications = async (id) => {
  try {
    const response = await instance.get(`/notifications/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteNotification = async (id) => {
  try {
    const response = await instance.delete(`/notifications/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
